import { h, Component } from "preact";
import { css } from "emotion";
import { reduxForm, Field, formValueSelector, change } from "redux-form";
import OptionsField from "../../components/fields/OptionsField";
import NumberIncrementorField from "../../components/fields/NumberIncrementorField";

export default class MerchandiseCard extends Component {
  render({
    itemName,
    description,
    itemImages,
    merchandiseOptions,
    merchOrder,
    index
  }) {
    const hasMoreThanOneOption = merchandiseOptions.length > 1;
    const allSoldOut = merchandiseOptions.reduce((cur, merchOpts) => {
      return cur && merchOpts.soldOut;
    }, true);
    const chosenOption = merchandiseOptions[merchOrder.selectedOption];
    const maxAmountPerOrder =
      merchandiseOptions[merchOrder.selectedOption].maxAmountPerOrder;
    const optionSoldOut = chosenOption.soldOut;
    let soldOutText = "";
    if (allSoldOut) {
      soldOutText = "This item has sold out";
    } else if (optionSoldOut) {
      soldOutText =
        "This option has sold out, other options are still available";
    }
    const cardStyle = css({
      display: "flex",
      flexDirection: "row",
      borderBottom: "solid 1px",
      borderColor: "#dedede",
      marginBottom: 15,
      "@media(max-width: 600px)": {
        flexDirection: "column"
      }
    });

    const column = css({
      flex: 1,
      marginRight: 8
    });
    const column2 = css({
      flex: 2,
      "@media(max-width: 600px)": {
        marginTop: 8
      }
    });
    const optionsStyle = css({
      display: "flex",
      marginTop: 18,
      flexDirection: "row",
      "@media(max-width: 600px)": {
        flexDirection: "column"
      }
    });
    const priceStyle = css({
      flex: 1,
      fontSize: 20,
      fontWeight: 600,
      paddingTop: 9,
      "@media(max-width: 600px)": {
        paddingTop: 0
      }
    });
    const optionStyle = css({
      flex: 2,
      // marginTop: 18,
      "@media(max-width: 600px)": {
        flexDirection: "column",
        borderRadius: 4,
        backgroundColor: "#f7f8ff",
        padding: 12,
        marginBottom: 16
      }
    });

    const labelStyle = css({
      flex: 2,
      width: "calc(100% - 100px)",
      textAlign: "right",
      paddingRight: 8,
      "@media(max-width: 600px)": {
        width: "100%"
      }
    });

    const optionFields = merchandiseOptions.map((opt, i) => {
      return { label: opt.optionName, value: i };
    });
    return (
      <div className={cardStyle}>
        <div className={column}>
          <ImageSelector itemImages={itemImages} />
        </div>
        <div className={column2}>
          <h4
            style={{
              fontSize: 16,
              fontWeight: 600
            }}
          >
            {itemName}
          </h4>
          <div style={{ fontSize: 14 }}>{description}</div>
          <div className={optionsStyle}>
            <h2 className={priceStyle}>{`$${chosenOption.price}`}</h2>
            <div className={optionStyle}>
              {hasMoreThanOneOption ? (
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div
                    style={{
                      flex: 1,
                      textAlign: "right",
                      paddingTop: 8,
                      paddingRight: 9
                    }}
                  >
                    Options:
                  </div>
                  <div style={{ flex: 2 }}>
                    <Field
                      name={`merchOrder[${index}].selectedOption`}
                      component={OptionsField}
                      options={optionFields}
                      includeSelectOption={false}
                      defaultValue={merchOrder.selectedOption}
                      formName={`merchandise`}
                    />
                  </div>
                </div>
              ) : null}
              <div
                style={{ display: "flex", flexDirection: "row", marginTop: 16 }}
              >
                <div className={labelStyle}>Quantity:</div>
                <div style={{ flex: 1, paddingTop: 0 }}>
                  <Field
                    name={`merchOrder[${index}].options[${
                      merchOrder.selectedOption
                    }].quantity`}
                    component={NumberIncrementorField}
                    disabled={optionSoldOut}
                    formName={`merchandise`}
                    max={maxAmountPerOrder}
                  />
                </div>
              </div>
              {optionSoldOut ? (
                <div
                  style={{
                    fontSize: 12,
                    color: "#DD1C1C",
                    flex: 1,
                    textAlign: "right"
                  }}
                >
                  {soldOutText}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const ImageSelector = ({ itemImages }) => {
  //for now just use the first image
  const firstImage = itemImages[0] || {};
  const imageSelectorStyle = css({
    width: 180,
    "@media(max-width: 600px)": {
      margin: "0 auto"
    }
  });
  const mainImage = css({
    width: 180,
    height: 180,
    borderRadius: 4
  });
  const subImageList = css({
    marginTop: 8,
    display: "flex",
    flexDirection: "row",
    width: 180
  });
  const subImage = css({
    width: 60,
    height: 60,
    borderRadius: 4,
    flex: 1
  });
  return (
    <div className={imageSelectorStyle}>
      <img className={mainImage} src={firstImage.url} />
      {/* <div className={subImageList}>
        <div className={subImage} />
        <div className={subImage} />
        <div className={subImage} />
      </div> */}
    </div>
  );
};



// WEBPACK FOOTER //
// ./routes/merchandise/MerchandiseCard.js